import React, { useContext } from 'react'
import Nav from 'react-bootstrap/Nav'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'shared/users/contexts/UserContext'
import { Tab } from 'features/declaration/form/components/editorTabs'

interface NavigationBarTabsProps {
  onTabChange: (tab: Tab) => void
  activeTab: Tab
}

function NavigationBarTabs({ onTabChange, activeTab }: Readonly<NavigationBarTabsProps>) {
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  const handleTabClick = (key: Tab) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    onTabChange(key)
  }

  return (
    <div className="d-flex justify-content-end pt-2 pb-2">
      <Nav
        variant="tabs"
        defaultActiveKey="general"
        activeKey={activeTab}
      >
        <Nav.Item>
          <Nav.Link eventKey="general" className="text-uppercase" href="#general" onClick={handleTabClick('general')}>
            {t('declaration.navbar.general')}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="transit-parties" className="text-uppercase" href="#transit-parties" onClick={handleTabClick('transit-parties')}>
            {t('declaration.navbar.transitParties')}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="house-consignments" className="text-uppercase" href="#house-consignments" onClick={handleTabClick('house-consignments')}>
            {t('declaration.navbar.house')}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="summary" className="text-uppercase" href="#summary" onClick={handleTabClick('summary')}>
            {t('declaration.navbar.summary')}
          </Nav.Link>
        </Nav.Item>
        {user?.role === 'ADMIN' ? (
          <Nav.Item>
            <Nav.Link eventKey="directo" className="text-uppercase" href="#directo" onClick={handleTabClick('directo')}>
              {t('declaration.navbar.directo')}
            </Nav.Link>
          </Nav.Item>
        ) : null }
        <Nav.Item>
          <Nav.Link eventKey="logs" className="text-uppercase" href="#logs" onClick={handleTabClick('logs')}>
            {t('declaration.headers.logs')}
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </div>
  )
}

export default NavigationBarTabs
